<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
  
  const arcsDOM = document.querySelector('.form__select select[name="options[Irrigated Acres]"]');
  
  let setArcQuantity = function() {
    
    if (arcsDOM != null) {
      
      const quantityDOM = document.querySelector('.quantity__container input.quantity__input');
      const arcsValue = arcsDOM.value;
      const minValue = arcsValue.split(' ')[0].split('-')[0];
      const maxValue = arcsValue.split(' ')[0].split('-')[1];
      
      quantityDOM.setAttribute('min', minValue);
      quantityDOM.setAttribute('max', maxValue);
      quantityDOM.value = minValue;
      quantityDOM.dispatchEvent(new Event('change'));

      console.log('min', minValue);
    }
    
  }

  if (arcsDOM != null) {
    
    document.querySelectorAll('.form__select.select select').forEach(select => {
      
      select.addEventListener('change', e => {
      
      setArcQuantity();
      
      });
      
    });
    
  }
  setArcQuantity()
});